import { createContext, useContext } from "react";
import { translations } from "@/i18n/translations";

export const LanguageContext = createContext({ lang: "fr", pageKey: "home", t: translations.fr });

export const useLang = () => useContext(LanguageContext);
